module.exports = __webpack_public_path__ + "static/media/glyphicons-halflings-regular.448c34a5.woff2";


//////////////////
// WEBPACK FOOTER
// ./html/assets/fonts/bootstrap/glyphicons-halflings-regular.woff2
// module id = 1005
// module chunks = 0